import {SolrSearchInput} from "../SolrSearchInput.jsx";
import {useEffect, useRef, useState} from "react";
import {Select} from "../Select.jsx";
import {Switch} from "../Switch.jsx";
import {futureDate, getDateStringFromInput, isValidDate, pastDate} from "../../services/date.service.js";
import {getURLParams, setURLParams} from "../../services/filter.service.js";
import {getTranslations} from "../../services/language.service.js";

const INITIAL_FILTER = {
    categories: undefined,
    mainTopics: undefined,
    eventTypes: undefined,
    kinds: undefined,
    places: undefined,
    startDateRange: '200001010000-209901010000',
    endDateRange: undefined,
    bookedOut: undefined,
    startDate: undefined,
    endDate: undefined,
    search: undefined
}

export const EventFilter = () => {
    const [filter, setFilter] = useState(Object.assign({}, INITIAL_FILTER, getURLParams()))
    const [facets, setFacets] = useState(undefined)
    const fromInput = useRef()
    const toInput = useRef()
    const LANG = getTranslations();
    const [showMobileFilters, setShowMobileFilters] = useState(false)


    useEffect(() => {
        document.addEventListener('facets', (e) => {
            setFacets(e.detail)
        });
        document.addEventListener('facets', () => {
            setFilter(Object.assign({}, INITIAL_FILTER, getURLParams()))
            if (filter.startDate !== undefined) {
                fromInput.current.value = filter.startDate;
            }
            if (filter.endDate !== undefined) {
                toInput.current.value = filter.endDate;
            }
            setTimeout(() => {
                if (filter.search !== undefined) {
                    onSearch(filter.search)
                }
            },300)

        }, {once: true})
    }, [])


    useEffect(() => {
        setURLParams(filter)
        document.dispatchEvent(new CustomEvent('filter', {
            detail: filter
        }))
    }, [filter])

    const isFilter = (name, value) => {
        return filter[name] === value
    }

    const toggleFilter = (name, value) => {
        setFilter((current) => {
            return {
                ...current,
                [name]: filter[name] === value ? undefined : value
            }
        })
    }

    const setDate = () => {
        let startDate = undefined;
        let endDate = undefined;
        if (isValidDate(fromInput.current.value)) {
            startDate = fromInput.current.value;
        }
        if (isValidDate(toInput.current.value)) {
            endDate = toInput.current.value;
        }
        setFilter((current) => {
            return {
                ...current,
                startDate: startDate,
                endDate: endDate,
            }
        })
        if (isValidDate(fromInput.current.value) || isValidDate(toInput.current.value)) {
            const from = isValidDate(fromInput.current.value) ? getDateStringFromInput(fromInput.current.value) : pastDate
            const to = isValidDate(toInput.current.value) ? getDateStringFromInput(toInput.current.value, '2359') : futureDate

            setFilter((current) => {
                return {
                    ...current,
                    startDateRange: `${pastDate}-${to}`,
                    endDateRange: `${from}-${futureDate}`,
                }
            })
        } else if (filter.startDateRange !== undefined && filter.endDateRange !== undefined) {
            setFilter((current) => {
                return {
                    ...current,
                    startDateRange: undefined,
                    endDateRange: undefined,
                }
            })
        } else if (filter.startDateRange !== undefined) {
            setFilter((current) => {
                return {
                    ...current,
                    startDateRange: undefined,
                }
            })
        } else if (filter.endDateRange !== undefined) {
            setFilter((current) => {
                return {
                    ...current,
                    endDateRange: undefined,
                }
            })
        }
    }

    const onSearch = (search) => {
        filter.search = search;
        setURLParams(filter)
        document.dispatchEvent(new CustomEvent('search', {
            detail: search
        }))
    }

    const getOptions = (filterName) => {
        if (facets === undefined) {
            return []
        }

        const f = facets.find(f => f.name === filterName)

        if (f === null) {
            return []
        }

        return f.options.map(o => o.value)
    }

    const onReset = () => {
        document.dispatchEvent(new CustomEvent('reset'))

        fromInput.current.value = ''
        toInput.current.value = ''
        setFilter(INITIAL_FILTER)
        setURLParams(filter)

    }

    return <div className={'bg-white aktuar-filter' + `${showMobileFilters ? ' show-mobile-filters' : ''}`}>
        <button onClick={() => setShowMobileFilters(!showMobileFilters)} className="mobile-filter-close"
                aria-label={LANG.close}></button>
        <div>
            <div className="filter-grid">
                <div className="form-group border-bottom form-group--categories">
                    <div className="headline_4 c-page">{LANG.categories}</div>
                    <div className="filter-tags">
                        {facets && facets.find(f => f.name === 'categories') && facets.find(f => f.name === 'categories').options.map((option, index) =>
                            <div className="checkbox" key={`category-${index}`}>
                                <label
                                    className={`${isFilter('categories', option.value) ? 'checked' : ''}`}
                                    htmlFor={`category-${option.value}`}>
                                    {LANG['category_' + option.label] ?? option.label}
                                    <input
                                        type="checkbox"
                                        id={`category-${option.value}`}
                                        checked={isFilter('categories', option.value)}
                                        onChange={() => toggleFilter('categories', option.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') {
                                                e.preventDefault();
                                                toggleFilter('categories', option.value);
                                            }
                                        }}
                                    />
                                </label>
                            </div>
                        )}
                    </div>

                </div>

                <div className="form-group border-bottom">
                    <div className={`solr-filter with-line`}>
                        <div className="headline_4 c-page">{LANG.freeSearch}</div>
                        <div style={{position: 'relative'}}>
                            <SolrSearchInput filters={{type_textExactS: 40}}
                                             onSelect={e => onSearch(e)} searchvalue={filter.search}></SolrSearchInput>
                        </div>
                    </div>

                </div>
            </div>

            <div className="filter-grid">
                <div className="form-group-2-cols">
                    <div className="form-group">
                        <div className="headline_4 c-page">{LANG.eventFormat}</div>
                        <div className="filter-tags">
                            <Select value={filter.eventTypes} options={getOptions('eventTypes')}
                                    onSelect={e => toggleFilter('eventTypes', e)}></Select>
                        </div>

                    </div>
                    <div className="form-group">
                        <div className="headline_4 c-page">{LANG.fieldOfExpertise}</div>
                        <div className="filter-tags">
                            <Select value={filter.kinds} options={getOptions('kinds')}
                                    onSelect={e => toggleFilter('kinds', e)}></Select>
                        </div>
                    </div>
                </div>


                <div className="filter-dates">
                    <div className="headline_4 c-page">{LANG.date}</div>
                    <div className="um-grid--2col">
                        <div className="form-group">
                            <input aria-label={LANG.dateFrom} ref={fromInput} className={`um-form-control`} type="date"
                                   onChange={_ => setDate()}/>
                        </div>
                        <div className="form-group">
                            <input aria-label={LANG.dateUntil} ref={toInput} className={`um-form-control`} type="date" onChange={_ => setDate()}/>
                        </div>
                        <div className="form-group col-2">
                            <div className="headline_4 c-page">{LANG.location}</div>
                            <div className="filter-tags">
                                <Select value={filter.places} options={getOptions('places')}
                                        onSelect={e => toggleFilter('places', e)}></Select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <hr/>
        <div className="d-flex space-between">
            <Switch checked={isFilter('bookedOut', false)}
                    onCheck={checked => toggleFilter('bookedOut', checked ? false : undefined)}>
                {LANG.showOnlyAvailableSeats}
            </Switch>
            <div className="event-filter-buttons">
                <button className="btn btn--icon icon--refresh" onClick={_ => onReset()}>{LANG.resetFilter}</button>
                <button onClick={() => setShowMobileFilters(!showMobileFilters)}
                        className="btn btn-primary mobile-filter-apply">{LANG.apply}
                </button>
            </div>

        </div>
        <button onClick={() => setShowMobileFilters(!showMobileFilters)}
                className="mobile-filter-trigger btn bg-primary-dark">Filter
        </button>
    </div>
}
